<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_return_tab_month_item') }} </v-tab>
      <v-tab href="#tab-2">{{ $t('quotation_tab_second') }}</v-tab>
      <v-tab-item value="tab-1">
        <new-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
          @setMonthBomItemIndex="setMonthBomItemIndex"
          @setBomMonth="setBomMonth"
        />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <new-discount-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :discountItemList="discountItemList"
          @setAllDiscount="setAllDiscount"
          @deleteDiscountItem="deleteDiscountItem"
          @setDiscountItem="setDiscountItem"
          @setDiscountItemIndex="setDiscountItemIndex"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import NewDiscountSetting from '@/components/Quotation/DiscountItem/NewDiscountSetting.vue'
import NewMonthSetting from '@/components/Quotation/MonthItem/NewMonthSetting.vue'
export default {
  components: { NewMonthSetting, NewDiscountSetting },
  name: 'NewCar',

  data: () => ({}),
  watch: {
    carQuantity (val) {
      if (this.monthItemList.length > 0) {
        this.monthItemList.forEach((element) => {
          if (element.MonthBomItems && element.MonthBomItems.length > 0) {
            element.MonthBomItems.forEach((ele) => {
              ele.RentQuantity = val
              ele.TotalPrice = val * ele.DiscountPrice * ele.Quantity
            })
          }
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
      }
    }
  },
  methods: {
    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    },
    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    },
    setMonthBomItemIndex (bomIndex) {
      this.$emit('setMonthBomItemIndex', bomIndex)
    },
    setBomMonth () {
      this.$emit('setBomMonth')
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType',
    'discountItemList'
  ]
}
</script>
